import React, { FC } from 'react';
import { toast } from 'react-toastify';
import CommissionHistoryReportDownload from 'components/Commission/CommissionHistoryReportDownload/CommissionHistoryReportDownload';
import Loading from 'components/Loading/Loading';
import { useGetAllCommissionDownloadsQuery } from 'reduxState/store/commission/api';
import { CommissionHistoryDownloadData } from 'reduxState/store/commission/types';
import '../../../pages/CommissionHistoryDownload/CommissionHistoryDownload.scss';

interface AppGroupCommissionHistoryDownloadProps {
  adminId: string;
  appName: string;
}

const AppGroupCommissionHistoryDownload: FC<AppGroupCommissionHistoryDownloadProps> = ({ adminId, appName }) => {
  const { data: commissionHistoryDownloads, isFetching, error } = useGetAllCommissionDownloadsQuery({
    appId: adminId,
  });

  if (error) {
    toast.error('Failed to get commission history download links.');
  }

  if (isFetching) {
    return <Loading data-testid="loading" />;
  }

  return (
    <div className="commission-download">
      <div className="commission-download-header">
        <h2 className="commission-download-title">App Group Commission History Downloads</h2>
      </div>
      {commissionHistoryDownloads?.length
        ? commissionHistoryDownloads.map((downloadData: CommissionHistoryDownloadData, index: number) => (
            <CommissionHistoryReportDownload appName={appName} downloadData={downloadData} key={index} />
          ))
        : 'No downloads to display'}
    </div>
  );
};

export default AppGroupCommissionHistoryDownload;
